import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { resolvePostAuthRedirect } from '../../../features/connections/shopify/pendingInstall';

const SignUpComplete = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="h6" fontWeight="medium" gutterBottom>
        Account Created Successfully!
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={4}>
        Your account has been set up and you're ready to go.
      </Typography>
      <Button 
        fullWidth 
        variant="contained"
        size="medium"
        onClick={() => navigate(resolvePostAuthRedirect())}
      >
        Get Started
      </Button>
    </Box>
  );
};

export default SignUpComplete; 